'use es6';

/* Libs  */
import { Route, Switch } from 'quartz-routing/react-router';
import { lazy } from 'react';
import DOIDefaultConfirmationContainer from './containers/DOIDefaultConfirmationContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SubscriptionPreferencesContainer = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "subscription-preferences-container" */'./containers/SubscriptionPreferencesContainer'));
const DOIConfirmationContainer = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "doi-confirmation-container" */'./containers/DOIConfirmationContainer'));
const BackUpPageContainer = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "backup-page-container" */'./containers/BackUpPageContainer.js'));
const ErrorPageContainer = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "error-page-container" */'./containers/ErrorPageContainer.js'));
const Routes = () => /*#__PURE__*/_jsxs(Switch, {
  children: [/*#__PURE__*/_jsx(Route, {
    component: SubscriptionPreferencesContainer,
    path: "/email"
  }), /*#__PURE__*/_jsx(Route, {
    component: DOIConfirmationContainer,
    path: "/doi"
  }), /*#__PURE__*/_jsx(Route, {
    component: DOIDefaultConfirmationContainer,
    path: "/doi-default-confirmation"
  }), /*#__PURE__*/_jsx(Route, {
    component: BackUpPageContainer,
    path: "/backup"
  }), /*#__PURE__*/_jsx(Route, {
    component: ErrorPageContainer,
    path: "/loadFailure"
  })]
});
export default Routes;